// extracted by mini-css-extract-plugin
export default {"faq":"UXji6","title":"ZclVg","top-nav":"YJIBg","expandingPanel-wrapper":"qWHZv","hidden":"Ixbfk","visibly":"VTZxV"};